import React from "react";
import Layout from "src/components/layout/website/Layout";

const AboutPage: React.FC = () => {
  return (
    <Layout
      meta={{
        title: "About — Invyntra",
        description:
          "Invyntra is a new inventory management platform built to make stock, purchase, and sales tracking effortless for small and growing businesses.",
      }}
    >
      <div className="min-h-screen bg-white py-20 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-4xl font-bold text-indigo-600 mb-6">
            About Invyntra
          </h1>
          <p className="text-gray-600 mb-8 max-w-3xl mx-auto">
            Invyntra was built with a single mission — to make inventory
            management effortless for small and medium businesses. We're in
            early access, working closely with our first users to get the
            product right before we scale up.
          </p>

          <div className="grid md:grid-cols-2 gap-10 mt-16 text-left">
            <div>
              <h2 className="font-semibold text-xl mb-2">Our Mission</h2>
              <p className="text-gray-600">
                To empower every business to handle inventory smarter — with
                real-time visibility, analytics, and automation that saves time
                and cost.
              </p>
            </div>
            <div>
              <h2 className="font-semibold text-xl mb-2">Our Story</h2>
              <p className="text-gray-600">
                Invyntra started as a focused answer to a common problem:
                stock, purchases, and sales tracked across spreadsheets and
                notebooks that never quite stay in sync. We're building it in
                the open, one real business's workflow at a time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AboutPage;
